<template lang="pug">
  .header-search
    base-button.button--icon.header-search__button(
      @click="showSearchForm = !showSearchForm"
    )
      icon(
        name="search"
        class="button__icon"
      )
    transition(name="fade")
      .header-search__content(
        v-if="showSearchForm"
      )
        h2.header-search__heading What are you looking for?
        navbar-search(
          ref="searchBox",
          v-model="searchParam",
          @open-results="showSubnav('search')",
          @close-results="hideSearch"
        )
        transition(name="fade")
          .header-search__results(
            v-if="subnav && subnav === 'search'",
            @mouseenter="overSearchResults = true",
            @mouseleave="overSearchResults = false"
          )
            navbar-search-results(
              ref="searchResults",
              :collection-handle="allProductsHandle",
              :search="searchParam",
              :suggestions="suggestedSearches",
              @selected="suggestionSelected",
              @close-results="hideSearch"
              :productImageBackgroundColor="productImageBackgroundColor"
            )
</template>

<script>
  import { allProductsHandle } from 'scripts/config/collections';
  import Icon from 'scripts/components/basic/Icon.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import NavbarSearch from 'scripts/components/site-header/NavbarSearch.vue';
  import NavbarSearchResults from 'scripts/components/site-header/NavbarSearchResults.vue';

  export default {
    name: 'HeaderSearch',
    components: {
      Icon,
      BaseButton,
      NavbarSearch,
      NavbarSearchResults,
    },
    props: {
      suggestedSearches: {
        type: Array,
        default: () => [],
      },
      productImageBackgroundColor: String,
    },
    data() {
      return {
        showSearchForm: false,
        searchParam: '',
        subnav: null,
        overSearchResults: false,
        allProductsHandle,
      };
    },
    methods: {
      showSubnav(subnav) {
        this.subnav = subnav;
      },
      hideSearch() {
        if (!this.overSearchResults) this.hideSubnav();
      },
      hideSubnav() {
        this.subnav = null;
      },
      suggestionSelected(suggestion) {
        this.$refs.searchBox.update(suggestion);
      },
    },
  };
</script>

<style scoped lang="scss">
  .header-search {}

  .header-search__button {}

  .header-search__content {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    padding: $spacing-unit * 4;
    background-color: $color-white;
    border-top: 1px solid $color-black;
    min-height: calc(100vh - #{$mobile-scroll-margin});

    @include desktop-up {
      min-height: calc(100vh - #{$desktop-scroll-margin});
    }
  }

  .header-search__heading {
    margin-top: $spacing-unit * 20;
    margin-bottom: $spacing-unit * 14;
    text-align: center;
    text-transform: capitalize;
  }
</style>
